import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { UsuarioAtendenteMultiselectComponent } from './usuario-atendente-multiselect.component';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        UsuarioAtendenteMultiselectComponent
    ],
    exports: [
        UsuarioAtendenteMultiselectComponent
    ]
})
export class UsuarioAtendenteMultiselectModule { }
